import { SmartImg } from "@/components/SmartImg";
import { Award, Building2, Cpu, HandHeart, HeartPulse, Users } from "lucide-react";

const BLOCKS = [
  [Building2, "Centro Médico IEMED", "Un espacio moderno dedicado a tu bienestar."],
  [HandHeart, "Filosofía de atención", "Escuchamos, explicamos y acompañamos."],
  [Cpu, "Tecnología médica", "Equipos de última generación para resultados precisos."],
  [HeartPulse, "Atención integral", "Diagnóstico, laboratorio e imagen en un solo lugar."],
  [Award, "Calidad", "Protocolos rigurosos en cada procedimiento."],
  [Users, "Compromiso con el paciente", "Tu tranquilidad es nuestra prioridad."],
];

export const InstitutionalSection = ({ assets }) => (
  <section id="nosotros" className="grain relative overflow-hidden bg-[#0B2545] py-24 text-white lg:py-32" data-testid="institutional-section">
    <div className="relative mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-12">
      <div className="lg:col-span-4">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#14B8A6]">Nosotros</p>
        <h2 className="mt-3 font-display text-3xl font-extrabold tracking-tight sm:text-4xl">Medicina moderna con rostro humano</h2>
        {assets.facility && (
          <div className="mt-10 aspect-[4/3] overflow-hidden rounded-[1.5rem] border border-white/10">
            <SmartImg src={assets.facility} fallback={assets.stock?.facility} framing={assets.framing?.facility} alt="Instalaciones de Centro Médico IEMED" sizes="(min-width: 1024px) 40vw, 100vw"
                      className="h-full w-full object-cover opacity-90" testid="facility-image" />
          </div>
        )}
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:col-span-8">
        {BLOCKS.map(([Icon, title, text], i) => (
          <div key={title} className="group rounded-[1.25rem] border border-white/10 bg-white/[0.04] p-7 transition-[background-color,border-color] duration-300 hover:border-[#14B8A6]/40 hover:bg-white/[0.07]"
               data-testid={`institutional-block-${i}`}>
            <span className="grid h-11 w-11 place-items-center rounded-xl bg-[#1E6FD9]/20 text-[#7fb2f5] transition-colors group-hover:bg-[#14B8A6]/20 group-hover:text-[#5eead4]">
              <Icon className="h-5 w-5" />
            </span>
            <h3 className="mt-5 font-display text-lg font-bold">{title}</h3>
            <p className="mt-1.5 text-sm leading-relaxed text-white/60">{text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
